<template>
  <div class="content if-profile">
    <div class="md-layout ratios-report">
      <MPHeader :headerData="this.headerData" />
      <!--<div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
        <div class="md-layout md-alignment-center">
          <div class="md-layout-item md-medium-size-70 md-xsmall-size-100 md-size-70 p-0">
            <h4>Industry Market Profile</h4>
            <ul>
              <li>
                  <h6><i class="md-icon">business_center</i>Industry:</h6>
                  <p>[{{ parseInt(this.bznaics_code) }}] {{ this.industry_title }}</p>
              </li>
              <li>
                <h6><i class="md-icon">business</i>Sector:</h6>
                <p>{{ this.sector_name }}</p>
              </li>
              <li>
                <h6><i class="md-icon">place</i>Market Area:</h6>
                <p>{{ this.display_area }}</p>
              </li>
            </ul>
          </div>
          <div class="md-layout-item md-xsmall-size-30 md-size-30 button-box">
            <md-button
              class="md-info pdf_btn access-button"
              :href="'/'"
              target="_blank"
              ><md-icon class="ml-5">picture_as_pdf</md-icon>Download
              PDF</md-button>
            <md-button
              class="md-info csv_btn access-button"
              v-on:click="downloadCSVData"
              ><md-icon class="ml-5">receipt_long</md-icon>Download
              CSV</md-button>
          </div>
        </div>
      </div>-->
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 marketprof-competitors p-0">
        <!-- <div class="finanical-report-messages">
          <h1 class="md-subheading profile-title">2020-2021 Cessation Rates</h1>
          <div class="">
            <md-dialog :md-active.sync="showDialog">
              <p>Cessation rates track the experience of business establishments, firms, small businesses, branches and startups
                doing business at the start of the time series, and still in operation today.<br><br>
                Firms which relocate but maintain independent operations are considered survivors if they do not move out of the
                jurisdiction being analyzed. Firms which become subsidiary locations, or whose location is terminated, are grouped
                with others which ceased operation. Any business entity which does not evidence ongoing operations (for example, by
                registering with government agencies, credit reporting services or business directories) is considered to have ceased
                viable operations and is classified in the "ceased operation" category.<br><br>
                Cessation rates occasionally reflect performance above 100% or below 0% due to business migration among industries
                (changes in primary business line) or (in the case of location‐specific cessation rates) to business relocations.
                Migrants within a NAICS‐2 industry sector are considered as survivors in the in‐ migrant classification.
              </p>
            </md-dialog>
            <md-card-header class="md-card-header-icon messages-box">
              <div class="card-icon md-ripple" @click="showDialog = true">
                <md-icon class="icon-arrow">double_arrow </md-icon>
                <md-icon>help</md-icon>
              </div>
            </md-card-header>
          </div>
        </div> -->
        <div class="md-card m-0">
          <div class="md-transparent finanical-report-messages">
            <nav-tabs-card class="p-0 m-0">
              <template slot="content">
                <md-card class="if_card">
                  <md-card-header>2020-2021 Cessation Rates</md-card-header>
                  <md-card-content>
                    <div class="md-layout p-4">
                      <div class="md-layout-item md-size-50">
                        <md-card class="md-card-profile">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                2020-2021 Cessation Rates
                              </div>
                            </h4>
                            <!-- <h4 class="title text-left">2020-2021 Cessation Rates</h4> -->
                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100 sub_table p-0 border-0">
                                <md-table v-model="tableDataCessationRates" table-header-color="blue"
                                  class="profit-and-loss-table">
                                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                                    <md-table-cell class="md-table-side-label">{{ item.name }}</md-table-cell>
                                    <md-table-cell v-for="key in Object.keys(item.dates)" :key="key"
                                      :md-label="years[key]">{{ item.dates[key] }}
                                    </md-table-cell>
                                  </md-table-row>
                                </md-table>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-50">
                        <md-card class="md-card-profile">
                          <md-card-content>
                            <chart-card header-animation="false" :chart-data="pieChart.data"
                              :chart-options="pieChart.options" chart-type="Bar" header-icon chart-inside-content
                              no-footer>
                              <template slot="chartInsideHeader">
                                <h4 class="title m-0">
                                  <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                    {{ this.chartData.title }}
                                  </div>
                                </h4>
                                <!-- <h4 class="title">
                                  {{this.chartData.title}}
                                  </h4> -->
                              </template>
                              <template slot="footer">
                                <div class="md-layout">
                                  <div class="md-layout-item md-size-100">
                                    <p class="common_footer black-color">Copyright © 2022 Bizminer. All Rights Reserved.
                                    </p>
                                  </div>
                                  <div class="md-layout-item">
                                    <span v-for="(v, i) in pieChart.options
                                      .legendNames" :key="i" :class="`ct-series-${i}`">
                                      <i class="fa fa-circle"></i>
                                      {{ v.name }} ({{ v.percentage }})
                                    </span>
                                  </div>
                                </div>
                              </template>
                            </chart-card>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-100">
                        <md-card class="md-card-profile">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                Competitive Market Narrative
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <!-- <div class="md-card-header md-card-header-icon md-card-header-blue"></div>
                              <h4 class="Performance Scores">
                                Competitive Market Narrative
                              </h4> -->
                            <div class="extra_space">
                              <p>
                                {{ cmnText.cessation }}
                              </p>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                      <div class="md-layout-item md-medium-size-100 md-size-100">

                        <md-card class="md-card-profile ">
                          <md-card-header>
                            <h4 class="title m-0">
                              <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                                <md-icon class="color-white">article</md-icon> Cessation
                              </div>
                            </h4>
                          </md-card-header>
                          <md-card-content>
                            <div class="md-layout">
                              <div class="md-layout-item md-medium-size-100 md-size-100">
                                <div class="extra_space">
                                  <!-- <h4 class="Performance Scores">
                                          Competitive Market Narrative
                                    </h4>-->
                                  <p>
                                    Cessation rates track the experience of business establishments, firms, small
                                    businesses, branches
                                    and startups doing business at the start of the time series, and still in operation
                                    today.<br><br>Firms
                                    which relocate but maintain independent operations are considered survivors if they
                                    do not move out
                                    of the jurisdiction being analyzed. Firms which become subsidiary locations, or
                                    whose location is
                                    terminated, are grouped with others which ceased operation. Any business entity
                                    which does not
                                    evidence ongoing operations (for example, by registering with government agencies,
                                    credit reporting
                                    services or business directories) is considered to have ceased viable operations and
                                    is classified
                                    in the "ceased operation" category.<br><br> Cessation rates occasionally reflect
                                    performance above
                                    100% or below 0% due to business migration among industries (changes in primary
                                    business line)
                                    or (in the case of location‐specific cessation rates) to business relocations.
                                    Migrants within a
                                    NAICS‐2 industry sector are considered as survivors in the in‐ migrant
                                    classification.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </md-card-content>
                        </md-card>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </template>
            </nav-tabs-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from '@/components';
import { ChartCard, NavTabsCard } from '@/components';
import { mapState } from 'vuex';
import formatData from '@/mixins/format-data';
import MPHeader from './MPHeader';

export default {
  components: {
    ChartCard,
    NavTabsCard,
    MPHeader,
    // Collapse,
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      showDialog: false,
      tableDataCessationRates: [],
      pieChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          showLabel: false,
          height: '250px',
          legendNames: [],
          labelInterpolationFnc: (value) => value,
        },
      },
      filtered_population: [],
      filtered_market_volume: [],
      filtered_market_share: [],
      filtered_annual_sales: [],
      filtered_penetration: [],
      filtered_employment: [],
      filtered_market_by_class: [],
      filtered_market_percent_by_class: [],
      filtered_average_sale_by_class: [],
      filtered_establishment_by_class: [],
      filtered_total_employment_by_class: [],
      filtered_average_employment_by_class: [],
      filtered_annual_sales_per_employee: [],
      filtered_average_annual_wage: [],
      filtered_rent_per_employee: [],
      filtered_startup_info: [],
      filtered_cessation_info: [],
      filtered_ownership_info: [],
      filtered_demographic_info: [],
      filtered_covid_info: [],
      filtered_covid_change_info: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      cessation: (state) => state.user.industryProfile.data['cessation'],
      years: (state) => state.user.industryProfile.years,
      release_years: (state) =>
        state.user.industryProfile.general.release_years,
      chartData: (state) =>
        state.user.industryProfile.charts.test['Cessation'][0],
      salesEmpSales: (state) =>
        state.user.industryProfile.data['salesEmpSales'],
      salesEmpCols: (state) => state.user.industryProfile['salesEmpCols'],
      salesEmpEmployment: (state) =>
        state.user.industryProfile.data['salesEmpEmployment'],
      tableCompetitors: (state) =>
        state.user.industryProfile.data['competitors'],
      bznaics_code: (state) => state.user.industryProfile.general.bznaics,
      sector_name: (state) => state.user.industryProfile.general.sector,
      industry_title: (state) => state.user.industryProfile.general.industry,
      release_display: (state) =>
        state.user.industryProfile.general['release_display'],
      update_month: (state) => state.user.industryProfile.updateMonth,
      display_area: (state) =>
        state.user.industryProfile.general.area_display_name,
      marketVolume: (state) => state.user.industryProfile.data['marketVolume'],
      marketShare: (state) => state.user.industryProfile.data['marketShare'],
      annualSales: (state) => state.user.industryProfile.data['annualSales'],
      annualSalesCols: (state) => state.user.industryProfile['annualSalesCols'],
      penetration: (state) => state.user.industryProfile.data['penetration'],
      employment: (state) => state.user.industryProfile.data['employment'],
      productivity: (state) =>
        state.user.industryProfile.data['productivityValues'],
      startupPerformance: (state) =>
        state.user.industryProfile.data['startupsValues'],
      startupRates: (state) => state.user.industryProfile.data['startupsIndex'],
      ownership: (state) => state.user.industryProfile.data['ownership'],
      demographics: (state) => state.user.industryProfile.data['demographics'],
      covid: (state) => state.user.industryProfile.data['covid'],
      covidColumns: (state) => state.user.industryProfile.data['covidColumns'],
      covidChange: (state) => state.user.industryProfile.data['covidChange'],
      covidChangeColumns: (state) =>
        state.user.industryProfile.data['covidChangeColumns'],
      cmnText: (state) => state.user.cmnText,
    }),
    getCsvData() {
      let csvData = [
        ['Bizminer Local Industry Market Report'],
        [this.bznaics_code, this.industry_title],
        ['Sector: ' + this.sector_name],
        [this.display_area],
        [
          'Data Time Series',
          this.release_years.toString() + '-' + this.update_month,
        ],
        ['Update Month', this.update_month],
        [''],
      ];
      csvData.push(['Industry Population Analyzed'], ['as of:', this.years]);
      this.filtered_population.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Annual Industry Market Volume($)'],
        ['as of:', this.years]
      );
      this.filtered_market_volume.forEach((e, i) => {
        e.forEach((k, i) => {
          if (typeof k === 'string' && k.includes('.')) {
            e[i] = k.replace(/\./g, '');
          }
        });
        csvData.push(e);
      });
      csvData.push([''], ['Share(%)'], ['', this.years]);
      this.filtered_market_share.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], [''], ['Average Annual Sales']);
      csvData.push(['', this.annualSalesCols]);
      this.filtered_annual_sales.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Rank'], ['as of:', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Market Penetration ($)']);
      csvData.push(['', this.years]);
      this.filtered_penetration.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        [
          'To enhance report load times Sales per Business Establishment values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ]
      );
      csvData.push([''], ['']);
      csvData.push(['Employment', this.years]);
      this.filtered_employment.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Market Volume by Employment Class', this.years]);
      this.filtered_market_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push(
        [''],
        ['Percent Market Volume by Employment Class', this.years]
      );
      this.filtered_market_percent_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Sales by Employment Class', this.years]);
      this.filtered_average_sale_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Establishments by Employment Class', this.years]);
      this.filtered_establishment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Total Employment by Class', this.years]);
      this.filtered_total_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Average Employment by Class', this.years]);
      this.filtered_average_employment_by_class.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '.');
        }
        csvData.push(e);
      });
      csvData.push([''], ['Productivity']);
      csvData.push(['Annual Sales per Employee', this.years]);
      this.filtered_annual_sales_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Average Annual Wage', this.years]);
      this.filtered_average_annual_wage.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Rent per Employee', this.years]);
      this.filtered_rent_per_employee.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['']);
      csvData.push(['Productivity Indices (%)', this.years]);
      csvData.push([''], [''], [''], [''], ['']);
      csvData.push(['Startup Activity and Performance']);
      csvData.push(['', this.years]);
      this.filtered_startup_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], [''], ['']);
      csvData.push(
        [
          'To enhance report load times Concentration values are reported in the IMR-2 file accessible from the My Reports page after you refresh the browser',
        ],
        [''],
        [''],
        [''],
        [''],
        ['Cessation Rates (2019-2020)'] // TODO: make this automatic.
      );
      this.filtered_cessation_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Ownership/Consolidation Trends', this.years]);
      this.filtered_ownership_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['Market Area Demographic Highlights']);
      csvData.push([
        '(based on zip codes co-joined with your market radius) (2015)',
      ]);
      this.filtered_demographic_info.forEach((element, index) => {
        element.forEach((el, i) => {
          csvData.push(el);
        });
        csvData.push(['']);
      });
      csvData.push([''], ['COVID IMPACT'], ['Month-to-Month Employment-Sales']);
      csvData.push(['', this.covidColumns]);
      this.filtered_covid_info.forEach((e, i) => {
        csvData.push(e);
      });
      csvData.push([''], ['% Change from Dec-19']);
      csvData.push(['', this.covidChangeColumns]);
      this.filtered_covid_change_info.forEach((e, i) => {
        csvData.push(e);
      });
      return csvData;
    },
  },
  mounted() {
    let me = this;
    this.tableDataCessationRates = Object.entries(
      this.cessation
    ).map(([table, data]) => ({ name: table, dates: Object.values(data) }));
    this.tableDataCessationRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    this.pieChart.options.legendNames = Object.entries(
      this.chartData.data
    ).map(([table, index]) => ({ name: table, percentage: index }));
    // this.pieChart.data.series = Object.values(this.chartData.data);
    this.pieChart.data.series = [{ data: Object.values(this.chartData.data), name: 'Test' }];
    this.pieChart.data.labels = ['Establishments (%)', 'Firms (%)', 'Small Businesses (%)', 'Startups (%)', 'Branches (%)'];

    let populationData = Object.entries(this.tableCompetitors).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    populationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_population.push(r);
    });

    let marketVolume = Object.entries(this.marketVolume).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    marketVolume.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithCommas(e);
      });
      return item;
    });
    let modifiedArr = [];
    marketVolume.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      modifiedArr.push(r);
    });
    modifiedArr.forEach((el) => {
      let modified = el.map(function (el) {
        if (typeof el === 'string' && el.includes(',')) {
          return el.replace(/,/g, '.');
        }
        return el;
      });
      this.filtered_market_volume.push(modified);
    });
    let marketShare = Object.entries(this.marketShare).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    marketShare.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_market_share.push(r);
    });
    this.filtered_market_share = this.filtered_market_share.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let tableAnnual = Object.entries(this.annualSales).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));
    tableAnnual.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    tableAnnual.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_annual_sales.push(r);
    });
    this.filtered_annual_sales = this.filtered_annual_sales.filter(
      (item, index) => {
        if (!item.includes('Your Firm')) {
          return item;
        }
      }
    );
    let penetrationData = Object.entries(this.penetration).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    penetrationData.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    penetrationData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_penetration.push(r);
    });
    let employmentData = Object.entries(this.employment).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    employmentData.forEach((element) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((element) => {
        r.push(element);
      });
      r.unshift(element.name);
      this.filtered_employment.push(r);
    });
    this.filtered_employment = this.filtered_employment.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let marketVolumeByClass = Object.entries(
      this.salesEmpSales.marketVolume
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_by_class.push(b);
    });
    let marketPercentVolumeByClass = Object.entries(
      this.salesEmpSales.percentMarket
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      marketPercentVolumeByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_market_percent_by_class.push(b);
    });
    let averageSaleByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageSaleByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_sale_by_class.push(b);
    });
    let establishmentByClass = Object.entries(
      this.salesEmpEmployment.establishments
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      establishmentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_establishment_by_class.push(b);
    });
    let totalEmploymentByClass = Object.entries(
      this.salesEmpEmployment.total
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      totalEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_total_employment_by_class.push(b);
    });
    let averageEmploymentByClass = Object.entries(
      this.salesEmpEmployment.average
    ).map(([name, data]) => ({
      name,
      dates: data,
    }));
    this.salesEmpCols.forEach((element, index) => {
      let b = [];
      averageEmploymentByClass.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_average_employment_by_class.push(b);
    });
    let annualSalesPerEmployee = Object.entries(
      this.productivity.spe
    ).map(([name, data]) => ({ name, dates: data }));
    annualSalesPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    annualSalesPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_annual_sales_per_employee.push(r);
    });
    this.filtered_annual_sales_per_employee = this.filtered_annual_sales_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let averageAnnualWage = Object.entries(
      this.productivity.annualWage
    ).map(([name, data]) => ({ name, dates: data }));
    averageAnnualWage.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    averageAnnualWage.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_average_annual_wage.push(r);
    });
    this.filtered_average_annual_wage = this.filtered_average_annual_wage.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let rentPerEmployee = Object.entries(
      this.productivity.rent
    ).map(([name, data]) => ({ name, dates: data }));
    rentPerEmployee.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    rentPerEmployee.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_rent_per_employee.push(r);
    });
    this.filtered_rent_per_employee = this.filtered_rent_per_employee.filter(
      (item, index) => {
        return !item.includes('Your Firm');
      }
    );
    let startupPerformance = Object.entries(this.startupPerformance).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupPerformance.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupPerformance.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let startupRates = Object.entries(this.startupRates).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    startupRates.map((item) => {
      item.dates = item.dates.map((e) => {
        return me.numberWithPoints(e);
      });
      return item;
    });
    startupRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_startup_info.push(r);
    });
    let cessationRates = Object.entries(this.cessation).map(
      ([table, data]) => ({
        name: table,
        dates: Object.values(data),
      })
    );
    cessationRates.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_cessation_info.push(r);
    });
    let ownerShip = Object.entries(this.ownership).map(([table, data]) => ({
      name: table,
      dates: Object.values(data),
    }));

    ownerShip.forEach((element, index) => {
      let v = Object.values(element.dates);
      let r = [];
      v.forEach((el) => {
        r.push(el);
      });
      r.unshift(element.name);
      this.filtered_ownership_info.push(r);
    });

    let demographicInfo = Object.entries(this.demographics).map(
      ([table, data]) => ({
        name: table,
        data: Object.values(data),
      })
    );
    demographicInfo.forEach((element, index) => {
      this.filtered_demographic_info[index] = [];
      this.filtered_demographic_info[index].push([element.name]);
      element.data.forEach((el, i) => {
        Object.keys(el).forEach((key) => {
          let a = el[key];
          a = a.map((e) => {
            if (typeof e === 'string' && e.includes(',')) {
              return me.numberWithPoints(e);
            } else {
              return e;
            }
          });
          if (!a.includes(key)) {
            a.unshift(key);
          }
          this.filtered_demographic_info[index].push(a);
        });
      });
    });
    let covidData = this.covidColumns.map((name, index) => ({
      name,
      dates: Object.values(this.covid).map((item) => item[index]),
    }));
    covidData.map((item) => {
      item.dates = item.dates.map((e) => {
        if (typeof e === 'string' && e.includes(',')) {
          return me.numberWithPoints(e);
        } else {
          return e;
        }
      });
      return item;
    });
    let covidKeys = Object.keys(this.covid);
    covidKeys.forEach((element, index) => {
      let b = [];
      covidData.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_covid_info.push(b);
    });

    let covidChangedData = this.covidChangeColumns.map((name, index) => ({
      name,
      dates: Object.values(this.covidChange).map((item) => item[index]),
    }));
    covidChangedData.map((item) => {
      item.dates = item.dates.map((e) => {
        if (typeof e === 'string' && e.includes(',')) {
          return me.numberWithPoints(e);
        } else {
          return e;
        }
      });
      return item;
    });
    let covidChangedKeys = Object.keys(this.covid);
    covidChangedKeys.forEach((element, index) => {
      let b = [];
      covidChangedData.forEach((el, num) => {
        b.push(el.dates[index]);
      });
      b.unshift(element);
      this.filtered_covid_change_info.push(b);
    });
  },
  methods: {
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if (x === null) {
        return x;
      } else {
        return x.replace(/,/g, '.');
      }
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Market Profile.csv';
      anchor.click();
    },
  },
};
</script>
<style lang="scss">
.marketprof-competitors {
  .md-toolbar {
    .md-collapse {
      display: block;

      .md-collapse-content {
        p {
          padding-left: 20px;
        }
      }
    }
  }

  .competitors-list {
    .md-collapse-title {
      font-size: 12px;
      font-weight: 300;
      margin-left: 25px;
    }

    .md-icon {
      font-size: 12px;
      font-weight: 300;
      transform: rotate(-90deg);
      left: 0;
      color: rgba(0, 0, 0, 0.54);
    }
  }

  .competitors-map {
    iframe {
      height: 300px !important;
    }
  }
}
</style>
